import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';

import { CustomerService } from '../customer/customer.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerEditService {

  private customerDataSubject = new BehaviorSubject<any>(null);
  public customerData$ = this.customerDataSubject.asObservable();
  private _controller = "common-customer";
  constructor(
    private http: HttpClient,
    private customerService: CustomerService
  ) {}

  /**
   * Load complete customer data for editing
   */
  loadCustomerData(customerId: number): Observable<any> {
    return this.customerService.getCompleteCustomerData(customerId)
      .pipe(
        tap(data => this.customerDataSubject.next(data))
      );
  }

  /**
   * Get current customer data from cache
   */
  getCurrentCustomerData(): any {
    return this.customerDataSubject.value;
  }

  /**
   * Update customer basic information
   */
  updateCustomerInfo(customerId: number, customerInfo: any): Observable<any> {
    const payload = {
      ...customerInfo.customer
    };

    return this.customerService.updateCustomer(customerId, payload)
      .pipe(
        tap(updatedData => {
          const currentData = this.getCurrentCustomerData();
          if (currentData) {
            const updatedCustomerData = {
              ...currentData,
              ...currentData.customer,
               ...customerInfo.customer 
            };
            this.customerDataSubject.next(updatedCustomerData);
          }
        })
      );
  }

  
  addRegion(data: any): Observable<any> {
    return this.http.post(`${this._controller}/add-region`, data);
  }

  
  addSite(data:any): Observable<any> {
    return this.http.post(`${this._controller}/add-site`, data);
  }

  /**
   * Add new admin user to customer
   */
  addAdminUser(adminUser: any): Observable<any> {
    const payload = {
      username: adminUser.username,
      password: adminUser.password,
      userDetails: adminUser.userDetails,
      roleNames: ['Admin'],
      customerId: adminUser.customerId,
      regionNames: adminUser.regionNames || []
    };

    return this.http.post(`${this._controller}/add-user`, payload);
  }

  /**
   * Add new operator user to customer
   */
  addOperatorUser(operatorUser: any): Observable<any> {
    const payload = {
      username: operatorUser.username,
      password: operatorUser.password,
      userDetails: operatorUser.userDetails,
      roleNames: ['Operator'],
      customerId: operatorUser.customerId,
      regionNames: operatorUser.regionNames || [],
      siteNames: operatorUser.siteNames || []
    };

    return this.http.post(`${this._controller}/add-user`, payload);
  }

  updateAdminUser(data:any): Observable<any> {
    return this.http.put(`${this._controller}/update-admin-user/${data.id}`, data);
  }
  updateOperatorUser(data:any): Observable<any> {
    return this.http.put(`${this._controller}/update-operator-user/${data.id}`, data);
  }

  /**
   * Clear cached data
   */
  clearCache(): void {
    this.customerDataSubject.next(null);
  }
}